
import { graphql, PageProps, useStaticQuery } from "gatsby"
import { IMissionSection, IHistorySection, IAboutUsSection, IEventsSection, ITimelineSection, IManagmentSection } from "interfaces/sections"
import { Brand, Csr, Information, Person, Post } from "types"
import OpenGraph from "types/opengraph"
import { StringMappingType } from "typescript"
import Media from "../types/media"


export type AboutusPageData = {
  mission: IMissionSection,
  history: IHistorySection,
  aboutus: IAboutUsSection,
  events: IEventsSection,
  timelines: ITimelineSection,
  managment: IManagmentSection,
  openGraph: OpenGraph,
}

const useAboutusPageData = (): AboutusPageData => {
  const { allWpPage } = useStaticQuery(graphql`
  query {
    allWpPage(filter: {slug: {eq: "onas"}}) {
      nodes {
        id
        title,
        mission {
          title: missiontitle,
          active: missionactive,
          description: missiondescription
        }
        aboutus{
          description: aboutusdescription
          image: aboutusimage{
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbySvg: localFile {
              publicURL
            }
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 500
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          active: aboutusactive
        }
        history{
          title: historytitle
          description: historydescription
          image: historyimage{
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbySvg: localFile {
              publicURL
            }
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 650
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          active: historyactive
        }
        events{
          title: datestitle
          active: datesactive
          events: datesevents{
            ... on WpEvent{
              eventOptions{
                date,
                event,
                image {
                  mediaItemUrl
                  mimeType
                  mediaType
                  altText
                  title
                  gatsbyImage: localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 600
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                        quality: 100
                      )
                    }
                  }
                }
              }
            }
          }
        } 
        timeline{
          active: timelineactive
          timelines: timelinetimelines{
            ...on WpTimeline{
              timelineOptions{
                image {
                  mediaItemUrl
                  mimeType
                  mediaType
                  altText
                  title
                  gatsbySvg: localFile {
                    publicURL
                  }
                  gatsbyImage: localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 400
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                      )
                    }
                  }
                }
                description
              }
            }
          }
        }
        managment{
          title: managmenttitle
          active: managmentactive
          members{
            ...on WpManagment{
              managmentOptions{
                image {
                  mediaItemUrl
                  mimeType
                  mediaType
                  altText
                  title
                  gatsbyImage: localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 1920
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                        quality: 100
                      )
                    }
                  }
                }
                description,
                role,
                name
              }
            }
          }
        }
        openGraphOptions{
          title: ogtitle
          description: ogdescription
          metatitle
          metadescription
          image: ogimage{
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 800
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      } 
    }
  }`)
  const pageData = allWpPage.nodes[0]
  return {
    mission: pageData.mission,
    history: pageData.history,
    aboutus: pageData.aboutus,
    events: pageData.events,
    openGraph: pageData.openGraphOptions,
    timelines: pageData.timeline,
    managment: pageData.managment

  }
}

export default useAboutusPageData